import { AccountInfoResponse } from 'types/billing';

/** Non-null trial shape from /account-info. */
export type TrialInfo = NonNullable<AccountInfoResponse['trial']>;

/**
 * Visual day-bands of the trial hero, escalating with urgency (per the final
 * design). The middle of the trial collapses to a single `exploring` band —
 * whether it shows the "recommended plan" framing is driven by the presence of
 * a usage-based recommendation (PLT-4059), not by the day number. The final day
 * is not its own band — it falls into `ending` and simply reads "1 day left"
 * (days-only countdown; no HH:MM:SS timer or "ends today" treatment).
 */
export type TrialBand = 'first-day' | 'exploring' | 'ending';

/**
 * Maps a trial snapshot to its day-band. Pure — no side effects, no async.
 *
 * @param trial Trial info from /account-info (PLT-4042).
 * @param endingThresholdDays Days-remaining threshold at which the trial reads as "ending". Defaults to 3.
 * @returns the TrialBand to render.
 */
export const trialDayBand = (
  trial: TrialInfo,
  endingThresholdDays = 3,
): TrialBand => {
  if (trial.daysRemaining <= endingThresholdDays) {
    return 'ending';
  }

  if (trial.dayNumber <= 1) {
    return 'first-day';
  }

  return 'exploring';
};
